export default __webpack_public_path__ + "static/media/settings.60e8b40a.svg";